import { render, staticRenderFns } from "./CallFailedDialog.vue?vue&type=template&id=96c84948"
import script from "./CallFailedDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallFailedDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports